import * as UI from "@iyk/ui"
import * as React from "react"
import { appConfig } from "../../../app-config.ts"

export const Layout = ({ children, hideBandImage = false }: Layout.Props) => {
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto">
      <div className="relative min-h-dvh text-foreground flex flex-col">
        <div className="absolute inset-0 h-2/3 w-full overflow-hidden select-none">
          <img
            src={appConfig.assets.images.background}
            className={classForBackgroundImage({
              hidden: hideBandImage
            })}
          />
          <div className="absolute bottom-0 left-0 w-full h-1/2 bg-[linear-gradient(to_top,_var(--gray-1),_rgba(0,0,0,0))]" />
        </div>

        <main className="flex-1 size-full flex flex-col z-10">{children}</main>
      </div>
    </div>
  )
}

export const MerchLandingLayout = ({ children }: MerchLandingLayout.Props) => {
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto">
      <div className="relative min-h-dvh text-foreground flex flex-col">
        <div className="absolute inset-0 w-full overflow-hidden select-none h-[calc(100vh*2/3)]">
          <img
            src={appConfig.assets.images.background}
            alt="Profile Background"
            className="size-full object-cover blur-md scale-110"
          />
          <div className="absolute inset-0 size-full bottom-0 left-0 bg-[linear-gradient(to_top,_var(--gray-1),_rgba(0,0,0,0.7))]" />
        </div>
        <main className="flex-1 size-full flex flex-col z-10">{children}</main>
      </div>
    </div>
  )
}

const classForBackgroundImage = UI.cva(
  "size-full object-cover object-top transition-all duration-500 blur-md scale-105 opacity-50",
  {
    variants: {
      hidden: {
        true: "opacity-0 invisible"
      }
    }
  }
)

export namespace Layout {
  export type Props = {
    children: React.ReactNode
    hideBandImage?: boolean
  }
}

export namespace MerchLandingLayout {
  export type Props = {
    children: React.ReactNode
  }
}
